/* @flow */

export const CHECKOUT_OVERLAY_COLOR = {
    BLACK: 'black',
    WHITE: 'white'
};



// WEBPACK FOOTER //
// webpack://paypal/src/constants/checkout.js